import { Box, Button } from '@mui/material';

const StepButtons = ({
  activeStep,
  onNextClick,
  onBackClick,
  nextDisabled
}: {
  activeStep: number;
  onBackClick: () => void;
  onNextClick: () => void;
  nextDisabled?: boolean;
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      {activeStep !== 0 && (
        <Button
          fullWidth
          disabled={activeStep === 0}
          sx={{
            height: 40,
            '&.MuiButton-outlined': {
              color: 'primary.main',
              borderColor: 'primary.main'
            },
            fontSize: 16,
            fontWeight: 600,
            mr: 1
          }}
          variant='outlined'
          onClick={onBackClick}
        >
          Back
        </Button>
      )}
      <Button
        fullWidth
        disabled={nextDisabled}
        sx={{
          height: 40,
          color: 'background.default',
          fontSize: 16,
          fontWeight: 600
        }}
        variant='contained'
        onClick={onNextClick}
      >
        Next
      </Button>
    </Box>
  );
};
export default StepButtons;
